import React from 'react'
import './preso.css'

import Footer from '../../components/footer/footer'

const Preso = ({ children }) => {
  return (
    <main>
      <div
      className='slide'
      style={{
        width: '75vw',
        height: '80vh',
      }}
    >
      <div>{children}</div>
    </div>
    <Footer />
    </main>
  )
}

export default Preso